// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__uGkPf","cell--current":"styles_cell--current__6eWws","skeleton-animation":"styles_skeleton-animation__TryO0"};